// Enterprise / organisation / region — one API for all three levels. Which level a
// request acts at comes from the caller's own role, so nothing here names a scope:
// the session already knows.
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';
const BASE = `${API_URL}/api/v1/hierarchy`;

export const getMe = () => axios.get(`${BASE}/me`).then((r) => r.data);
export const getChildren = () => axios.get(`${BASE}/children`).then((r) => r.data);
export const getCredits = () => axios.get(`${BASE}/credits`).then((r) => r.data);

// The whole subtree, with balances and headline counts — the overview screen.
export const getTree = () => axios.get(`${BASE}/tree`).then((r) => r.data);

// Everyone working beneath this node. Staffing, not clinical: no patient is read.
export const getPeople = () => axios.get(`${BASE}/people`).then((r) => r.data);

// Read one node BELOW yours. This is what "look into an organisation" means for an
// enterprise admin: they read it from their own session rather than becoming its
// administrator, so there is no route from here to a patient.
export const getNode = (scope, id) =>
  axios.get(`${BASE}/nodes/${scope}/${id}`).then((r) => r.data);

// Positive hands sessions down to a child; negative takes them back into this pool.
export const allocate = (childScope, childId, sessions, note) =>
  axios.post(`${BASE}/credits/allocate`,
    { child_scope: childScope, child_id: childId, sessions, note })
    .then((r) => r.data);

export const setChildUnlimited = (childScope, childId, unlimited) =>
  axios.post(`${BASE}/credits/unlimited`,
    { child_scope: childScope, child_id: childId, unlimited })
    .then((r) => r.data);

export const listAdmins = () => axios.get(`${BASE}/admins`).then((r) => r.data);
export const addAdmin = (body) => axios.post(`${BASE}/admins`, body).then((r) => r.data);
export const removeAdmin = (userId) =>
  axios.delete(`${BASE}/admins/${userId}`).then((r) => r.data);

// Region only: the offices where one of the region's admins also practises as a
// provider. The list is the whole answer — offices left out lose the role.
export const setAdminProviderOffices = (userId, clinicIds) =>
  axios.put(`${BASE}/admins/${userId}/provider`, { clinic_ids: clinicIds }).then((r) => r.data);

// Region only: the region's own practice (created on first use), where its providers
// see patients and record sessions. Returns { id, name, created }.
export const openRegionPractice = () =>
  axios.post(`${BASE}/region-practice`).then((r) => r.data);

export const listChildAdmins = (childScope, childId) =>
  axios.get(`${BASE}/children/${childScope}/${childId}/admins`).then((r) => r.data);
export const addChildAdmin = (childScope, childId, body) =>
  axios.post(`${BASE}/children/${childScope}/${childId}/admins`, body).then((r) => r.data);

// Enterprise admins only: open a new organisation beneath themselves.
export const createOrganization = (body) =>
  axios.post(`${BASE}/organizations`, body).then((r) => r.data);

// Offices asking this level for more sessions, and the answer to one.
export const listCreditRequests = () =>
  axios.get(`${BASE}/credit-requests`).then((r) => r.data);
export const answerCreditRequest = (id, action, sessions, note) =>
  axios.post(`${BASE}/credit-requests/${id}`, { action, sessions, note }).then((r) => r.data);
